import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	Input,
	inject,
	Injector,
	signal,
	WritableSignal,
	OnChanges,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreSectionComponent } from '@core/ui';
import {
	isFieldViewModel,
	isSubSectionViewModel,
} from '@globalUtils/client-intake';
import { Form, FormFieldType } from '@models/client-intake';
import { FormFieldComponent } from '../form-field/form-field.component';
import { IntakeFormVmService } from '../../services/intake-form-vm.service';
import { FormViewModel } from '@domain/intake-form-client-portal';

@Component({
	selector: 'app-intake-form-renderer',
	templateUrl: './intake-form-renderer.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		CommonModule,
		ReactiveFormsModule,
		FormFieldComponent,
		CoreSectionComponent,
	],
	providers: [IntakeFormVmService],
})
export class IntakeFormRendererComponent implements OnChanges {
	@Input() intakeForm: Form | null;

	private injector = inject(Injector);
	private intakeFormVmService = inject(IntakeFormVmService);

	formViewModel_: WritableSignal<FormViewModel | null> = signal(null);

	isFieldViewModel = isFieldViewModel;
	isSubSectionViewModel = isSubSectionViewModel;

	FormFieldTypeEnum = FormFieldType;

	ngOnChanges(): void {
		if (!this.intakeForm) {
			this.formViewModel_.set(null);
			return;
		} else {
			const formViewModel = this.intakeFormVmService.createFormViewModel(
				this.intakeForm,
				this.injector,
			);
			this.formViewModel_.set(formViewModel);
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	trackBySection(_: number, s: any): string {
		return s.section.title;
	}
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	trackByItem(index: number, item: any): string | number {
		return item.field?.id || item.subSection?.title || index;
	}
}
